import { useContext } from 'react';

import ParkingStatusContext from 'src/providers/ParkingStatusProvider';

export const useParkingStatus = () => {
    const ctx = useContext(ParkingStatusContext);

    if (!ctx) throw new Error('useParkingStatus must be used within ParkingStatusProvider');
    return ctx;
};
